interface IIconWithDesc {
  icon: string;
  text: string;
  alt: string;
  className?: string;
}

export const IconWithDesc = ({ icon, text, alt, className }: IIconWithDesc) => {
  return (
    <section
      className={["flex w-min flex-col items-center gap-fh-medium", className]
        .filter(Boolean)
        .join(" ")}
    >
      <img
        src={icon}
        alt={alt}
        className="h-16 w-16 object-contain"
        width={64}
        height={64}
        loading="lazy"
        decoding="async"
      />
      <h2 className="text-center">{text}</h2>
    </section>
  );
};
